import React from 'react';
import {connect} from 'react-redux';
import {hashHistory} from "react-router";
import {FormattedMessage, injectIntl} from "react-intl";

import {showOrderCompletePopup} from "../../../actions/shoppingCartFunctions";
import Analytics from "../../../analytics";
import ProjectScopeFunctions from "../../projectScope/projectScopeFunctions";
import {
  changeActivePartRelatedItemIndex, setCameFromPage,
  setQtActiveCategory,
  setVanityType,
  toggleBathroomVisualizerOpen, toggleSelectionWindow
} from "../../../actions/actionFunctions";
import {isIframe} from "../../../misc/helpers";

class OrderCompletePopup extends ProjectScopeFunctions {

  backToHomeClick = () => {
    Analytics.sendClickEvent("order-complete-back-to-home");
    this.closePopup();
    if (this.props.fabricatorData.websiteUrl) {
      let websiteUrl = this.props.fabricatorData.websiteUrl;
      websiteUrl = websiteUrl.includes("http") ? websiteUrl : "//" + websiteUrl;
      if (isIframe()) {
        window.parent.location.href = websiteUrl;
      } else {
        window.location.href = websiteUrl;
      }
    } else {
      hashHistory.push("quote-design");
    }
  };

  getAnotherQuoteClick = () => {
    Analytics.sendClickEvent("order-complete-get-another-quote");
    this.closePopup();
    const section = this.getSections()[0];
    this.goToMaterialsPageCommon(section.items[0].part, section.title);
    window.location.reload();
  };

  closePopup = () => {
    this.props.showOrderCompletePopup(false);
  };

  getPopupText = () => {
    const {intl, fabricatorData} = this.props;
    return {
      title: intl.formatMessage({
        id: fabricatorData.isFlexFinish
          ? "orderCompletePopup.title.flexFinish"
          : fabricatorData.settings.enableQuote ? "orderCompletePopup.title.enableQuote" : "orderCompletePopup.title.default"
      }),
      message1: intl.formatMessage({
        id: fabricatorData.isFlexFinish
          ? "orderCompletePopup.message1.flexFinish"
          : fabricatorData.isLowes
            ? "orderCompletePopup.message1.isLowes"
            : fabricatorData.settings.enableQuote
              ? "orderCompletePopup.message1.enableQuote"
              : "orderCompletePopup.message1.default"
      }),
      message2: intl.formatMessage({
        id: fabricatorData.isFlexFinish
          ? "orderCompletePopup.message2.flexFinish"
          : fabricatorData.isLowes ? "orderCompletePopup.message2.isLowes" : "orderCompletePopup.message2.default"
      }),
    }
  }

  viewInSalesForce = () => {
    const {serverState} = this.props;
    let payload = {QCJobId: document.kvConfig.jobId || serverState.jobId};
    console.log('attempting to view job in SalesForce', payload);
    let eventPayload = {name: 'quoteCountertops.viewJobInSF', payload }
    try {
      window.Sfdc.canvas.client.publish(sr.client, eventPayload);
    } catch(e) {
      console.log('unable to send via salesforce viewpage');
    }
    if(typeof(sfdcMessage) !== 'undefined') {
      sfdcMessage.postMessage(eventPayload);
    }
  }

  scheduleFlexFinishAppointment = () => {
    this.closePopup();
    const sheduleUrl = "https://online-booking.workiz.com/?ac=e25ee7320648ace466e5e45d3bc81024fc9f10d661cf3cd677048b1cdff14f11&adgroup=qb";
    window.open(sheduleUrl, "_blank");
  }

  render() {

    if (!this.props.orderCompletePopupVisible) {
      return null
    }

    const popupText = this.getPopupText();
    const {fabricatorData} = this.props;
    // const cloneButtonVisible = !!document.kvConfig.isBackend && !fabricatorData.isCaesarStone
    const severalButtons = false;

    return (
      <div className="overlay">
        <div className="ui-popup order-complete-popup">
          <button className="ui-close contract-popup__close" onClick={this.closePopup}/>
          <div className="ui-popup__body">
            <div className="order-complete">
              <div className={"order-complete-image" + (fabricatorData.isFlexFinish ? " order-complete-image--flex-finish" : "")}/>
              <div className="order-complete-body">
                <h3 className="order-complete-title">
                  <span className="order-complete-title__text">{popupText.title}</span>
                </h3>
                <p className="order-complete-text">{popupText.message1}</p>
                {popupText.message2 ? <p className="order-complete-text">{popupText.message2}</p> : null}
              </div>
            </div>
          </div>
          <div className={"ui-popup__footer" + (severalButtons ? " ui-popup__footer--with-sides" : "")}>
            {severalButtons ? (
              <div className="ui-popup__footer-left"/>
            ) : null}
            <div className="ui-popup__footer-right">
              {(window.salesForceLoaded || typeof(sr) != 'undefined') ? (
                <button className="ui-button2 ui-button2--blue ui-button3--wide"
                        onClick={this.viewInSalesForce}>
                  <FormattedMessage id="orderCompletePopup.viewInSalesForce"/>
                </button>
              ) : fabricatorData.isFlexFinish ? null : (
                <button className="ui-button2 ui-button2--blue ui-button3--wide"
                        onClick={this.backToHomeClick}>
                  <FormattedMessage id="orderCompletePopup.buttonBackToHome"/>
                </button>
              )}
              <button className={"ui-button2 ui-button2--green"
              + (fabricatorData.isLowes || fabricatorData.isFlexFinish ? " ui-button3--wide2": " ui-button3--wide")}
                      onClick={fabricatorData.isFlexFinish ? this.scheduleFlexFinishAppointment : this.getAnotherQuoteClick}>
                <FormattedMessage id={fabricatorData.isFlexFinish
                  ? "orderCompletePopup.buttonGetAnotherQuote.flexFinish" : "orderCompletePopup.buttonGetAnotherQuote"}/>
              </button>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = store => {
  return {
    orderCompletePopupVisible: store.cartState.orderCompletePopupVisible,
    fabricatorData: store.fabricatorState,
    serverState: store.serverState
  }
};

const mapDispatchToProps = {
  showOrderCompletePopup,
  toggleBathroomVisualizerOpen,
  setVanityType,
  setQtActiveCategory,
  changeActivePartRelatedItemIndex,
  toggleSelectionWindow,
  setCameFromPage
};

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(OrderCompletePopup)
)
